import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import moment from "moment";
import "moment/locale/ja";
import "moment/locale/tr";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class DateComponent extends React.Component {
  static contextType = Web3StatusContext;

  state = { dataKey: null };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const dataKey = contract.methods[this.props.dateName].cacheCall(this.props.getterParameter);
  
    // save the `dataKey` to local component state for later reference
    this.setState({ dataKey });
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    // using the saved `dataKey`, get the variable we're interested in
    const unixdate = GAMEFORESTSale[this.props.dateName][this.state.dataKey];

    if(this.context.i18n != null)
      moment.locale(this.context.i18n.languages[0]);

    if(unixdate !== undefined) {
      var dateString = moment.unix(unixdate.value).format("DD MMM YYYY HH:mm ZZ");
      return <div>{dateString}</div>;
    }
    
    return '--';
  }
};

export default DateComponent;